import { useContext, useEffect, useState } from 'react';
import { Module } from '../../../api/module';
import useThrowAsyncError from '../../../hooks/useThrowAsyncError';
import { fetchModules } from '../api/methodsApi';
import UserModuleContext from '../../../contexts/UserModuleContext';

function useModules(methodId?: string) {
  const handleError = useThrowAsyncError();

  const [modules, setModules] = useState<Module[]>([]);
  const [loading, setLoading] = useState(false);
  const { userModules } = useContext(UserModuleContext);

  useEffect(() => {
    if (!methodId) return;

    setLoading(true);

    async function getModules(): Promise<void> {
      try {
        const fetched = await fetchModules(methodId!);
        setModules(fetched);
      } catch (e) {
        handleError(e);
      } finally {
        setLoading(false);
      }
    }

    getModules();
  }, [handleError, methodId]);

  const modulesWithDemoLicense = modules.map(module => ({
    ...module,
    licenses: {
      ...module.licenses,
      hasDemoProductLicenseForTeacher: userModules.some(userModule => userModule.id === module.id && userModule.isDemo),
    },
  }));

  function resetModules() {
    setModules([]);
  }

  return { modules: modulesWithDemoLicense, loading, resetModules };
}

export default useModules;
